<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :checkStrictly="false"
                        @onDbClick="onDbClickTree"
                        @onClick="onDbClickTree"
                        :showBox="false"
                        :isPaging="true"
                        :defaultProps="defaultProps"
                        :nodeKey="nodeKey"
                        :isDistributed="false"
                        :interfaceName="interfaceName"
                        :params="params"
                        ref="TdTree"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container style="width:100%">
            <el-header>
                <el-form :inline="true" :model="fromPost" ref="fromPost" class="demo-form-inline" :rules="rules">
                    <el-row :gutter="20">
                        <el-col>
                            <td-permission :permissions="permissionsView">
                                <div slot="havePermission">
                                    <el-form-item :label="$t('pgCommon.PERSON_NAME')">
                                        <td-input v-model="personnelInfo.name"> </td-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('pgCommon.POST_STATION')">
                                        <td-select
                                            v-model="personnelInfo.postStation"
                                            :placeholder="$t('common.PLEASE_SELECT')"
                                            :options="this.postStationList"
                                            keys="sId"
                                            text="sName"
                                            :clearable="false"
                                        >
                                        </td-select>
                                    </el-form-item>
                                </div>
                            </td-permission>
                            <el-form-item class="paddingLeft10">
                                <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                                <td-button :permissions="permissionsAdd" v-show="!isUnAssigned" @click="btnAdd">{{ $t('pgCommon.ASSIGNED') }}</td-button>
                                <td-button :permissions="permissionsAdd" v-show="!isUnAssigned" @click="btnBatchSet">{{ $t('pgCommon.BATCH_SET') }}</td-button>
                                <td-button :permissions="permissionsDel" v-show="!isUnAssigned" @click="batchDelete">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main style="padding-bottom: 0px;">
                <td-permission :permissions="permissionsView" style="width:100%;">
                    <div slot="havePermission">
                        <td-table
                            :columns="columns"
                            :dataSource="tableData"
                            :pageSize="pageSize"
                            :currentPage="currentPage"
                            :total="total"
                            ref="personnel"
                            rowKey="sId"
                            :hasLoading="loading"
                            @handleSizeChange="handleSizeChange"
                            @currentChange="handleCurrentChange"
                        >
                        </td-table>
                    </div>
                </td-permission>
                <!-- 加载dialog -->
                <dialog-PersonnelInfo
                    v-if="dialogPersonnelVisible"
                    :isAddData="isAddData"
                    :structureItem="structureItem"
                    :dialogPersonnelVisible="dialogPersonnelVisible"
                    :title="dialogTitle"
                    ref="personnelInfo"
                    @personnelDialogClose="personnelDialogClose"
                    @queryList="queryList"
                ></dialog-PersonnelInfo>

                <!-- 加载dialog -->
                <dialog-EditPersonnelInfo
                    v-if="dialogVisible"
                    :dialogVisible="dialogVisible"
                    :editItem="editItem"
                    :structureItem="structureItem"
                    :title="dialogEditTitle"
                    ref="editPersonnelInfo"
                    @dialogClose="dialogClose"
                    @queryList="queryList"
                ></dialog-EditPersonnelInfo>

                <dialog-BatchSetLeader
                    v-if="dialogSetVisible"
                    :dialogVisible="dialogSetVisible"
                    :editItem="editItem"
                    :structureItem="structureItem"
                    :title="dialogSetTitle"
                    ref="batchSetLeader"
                    @dialogClose="dialogSetClose"
                    @queryList="queryList"
                ></dialog-BatchSetLeader>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import personnelApi from './assets/api.js';
import dialogPersonnelInfo from './components/dialogPersonnelInfo.vue';
import dialogEditPersonnelInfo from './components/dialogEditPersonnelInfo.vue';
import dialogBatchSetLeader from './components/dialogBatchSetLeader.vue';
export default {
    components: {
        'dialog-PersonnelInfo': dialogPersonnelInfo,
        'dialog-EditPersonnelInfo': dialogEditPersonnelInfo,
        'dialog-BatchSetLeader': dialogBatchSetLeader
    },
    created() {
        this.queryPortStationFlag = true;
        this.queryPortStation();
    },
    mounted() {},
    activated() {
        if (!this.queryPortStationFlag) {
            this.queryPortStation();
        }
        this.queryPortStationFlag = false;
    },
    data() {
        return {
            permissionsView: ['staff:view'],
            permissionsAdd: ['staff:allot'],
            permissionsDel: ['staff:cancelAllot'],
            permissionsEdit: ['staff:edit'],
            queryPortStationFlag: false,
            structureItem: [],
            dialogPersonnelVisible: false,
            dialogVisible: false,
            dialogSetVisible: false,
            isUnAssigned: false,
            dialogEditTitle: '',
            dialogSetTitle: '',
            // lazyloading: true,
            loading: false, // 按钮是否为加载状态
            defaultProps: { label: 'caption', id: 'id', children: 'children', imgName: 'sIcon', parentId: 'parentId' },
            nodeKey: 'id',
            interfaceName: { query: '/staffManager/queryStaffOrgTree', search: '/staffManager/queryStaffOrgTree' },
            params: {
                needPage: true,
                pageSize: 50,
                currentPage: 1,
                isOrgTree: true
            },
            personnelInfo: {
                name: '',
                postStation: ''
            },
            currentTreeItem: null,
            postStationList: [],
            postStationAll: {
                sId: '',
                sName: this.$t('pgCommon.ALL')
            },
            columns: [
                {
                    prop: 'staffName',
                    label: this.$t('pgCommon.PERSON_NAME')
                },
                {
                    prop: 'structureName',
                    label: this.$t('pgCommon.DEPARTMENT')
                },
                {
                    prop: 'stationName',
                    label: this.$t('pgCommon.POST_STATION')
                },
                {
                    prop: 'leaderName',
                    label: this.$t('pgCommon.DIRECT_LEADER')
                },
                {
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        let operateList = [];
                        if (this.currentTreeItem.caption != this.$t('pgCommon.UN_ASSIGNED')) {
                            let editBtn = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            );
                            let status = createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            );
                            operateList.push(editBtn, status);
                        }
                        return operateList;
                    }
                }
            ],
            tableData: [],
            pageSize: 10,
            currentPage: 1, // 当前页
            total: 0 // 总条数
        };
    },
    methods: {
        // 树形双击事件
        onDbClickTree: function(item) {
            if (item.id === window.pangu.common.orgNotAllocationId) {
                this.isUnAssigned = true;
            } else {
                this.isUnAssigned = false;
            }
            this.currentTreeItem = item;
            this.btnQuery();
        },
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            let item = this.getParam();
            this.queryData(item);
        },

        queryList() {
            this.loading = true;
            let item = this.getParam();
            this.queryData(item);
        },

        // 查询职位信息
        queryPortStation() {
            personnelApi.queryPortStation({}, response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleAuthList', response.data.statusMessage);
                    return;
                }
                this.postStationList = [];
                this.postStationList.push(this.postStationAll);
                let flag = false;
                response.data.content.forEach(element => {
                    let param = {
                        sId: element.sId,
                        sName: element.sName
                    };
                    this.postStationList.push(param);
                    if (this.personnelInfo.postStation && element.sId == this.personnelInfo.postStation) {
                        flag = true;
                    }
                });
                if (!flag) {
                    this.personnelInfo.postStation = '';
                }
            });
        },

        // 获取查询参数
        getParam: function() {
            let queryVo = {
                needPage: true,
                recursiveQuery: true,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            if (this.currentTreeItem != null && this.currentTreeItem.id != '') {
                queryVo.structureId = this.currentTreeItem.id;
            }
            if (this.personnelInfo.name !== null && this.personnelInfo.name !== undefined && this.personnelInfo.name !== '') {
                queryVo.staffName = this.personnelInfo.name;
            }
            if (this.personnelInfo.postStation != null && this.personnelInfo.postStation != undefined && this.personnelInfo.postStation != '') {
                queryVo.stationId = this.personnelInfo.postStation;
            }
            return queryVo;
        },

        // 查询数据
        queryData: function(queryVo) {
            let _this = this;
            let json = JSON.stringify(queryVo);
            personnelApi.getAllStaffInfo(json, response => {
                this.loading = false;
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    _this.$log.error('personnelApi.getAllStaffInfo', response.data.statusMessage);
                    return;
                }
                _this.tableData = response.data.content;
                _this.total = response.data.count;
                _this.loading = false;
            });
        },
        // 控制每页条数变化
        handleSizeChange(val) {
            let param = this.getParam();
            this.pageSize = val;
            param.pageSize = val;
            this.queryData(param);
        },

        // 控制页数变化
        handleCurrentChange(val) {
            this.currentPage = val;
            let param = this.getParam();
            this.queryData(param);
        },

        // 批量删除方法
        deleteOrgs: function(orgIds, deleteItem) {
            let deleteInfo = {
                orgIds: orgIds
            };
            personnelApi.deleteStaffRelationInfo(JSON.stringify(deleteInfo), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data) {
                    if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.$refs.TdTree.editTreeNode(deleteItem, 'delete', this.nowTreeItem);
                        if (orgIds[0] === this.nowTreeItem.orgId) {
                            this.onDbClickTree(this.rootTreeItem);
                        } else {
                            this.queryTabList();
                        }
                    } else {
                        this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    }
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('pgCommon.OPERATION_FAIL') });
                }
            });
        },
        // 批量删除
        batchDelete() {
            let rows = this.$refs.personnel.getSelectAllRows();
            let relationIds = [];
            for (let i = 0; i < rows.length; i++) {
                const element = rows[i];
                relationIds.push(element.sId);
            }
            if (relationIds.length === 0) {
                this.$message({ type: 'warning', showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_DELSTAFF') });
                return;
            }
            this.delelete(relationIds);
        },

        // 删除接口
        delelete(relationIds) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    personnelApi.deleteStaffRelationInfo(JSON.stringify(relationIds), response => {
                        if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('portStationManagerController/deletePortStation', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('roleInfo/btnDelete---- Fail')
                });
        },
        btnAdd: function() {
            this.dialogPersonnelVisible = true;
            this.structureItem = this.currentTreeItem;
            this.dialogTitle = this.$t('pgCommon.ASSIGNED_STAFF');
        },
        btnEdit: function(item) {
            this.dialogVisible = true;
            this.editItem = item;
            this.structureItem = { id: item.structureId };
            this.dialogEditTitle = this.$t('pgCommon.MODIFY_STAFF');
        },
        btnBatchSet: function(item) {
            let items = this.$refs.personnel.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            for (let i = 0; i < items.length; i++) {
                if (items[i].structureId != this.currentTreeItem.id) {
                    this.$message({ showClose: true, message: this.$t('pgCommon.IS_NOT_SAME_ORG'), type: 'warning' });
                    return;
                }
            }
            this.dialogSetVisible = true;
            this.editItem = item;
            this.structureItem = this.currentTreeItem;
            this.dialogSetTitle = this.$t('pgCommon.BATCH_SET');
        },

        // 关闭dialog树形
        personnelDialogClose: function() {
            this.dialogPersonnelVisible = false;
        },

        // 关闭dialog树形
        dialogClose: function() {
            this.dialogVisible = false;
        },
        // 关闭dialog树形
        dialogSetClose: function() {
            this.dialogSetVisible = false;
        }
    }
};
</script>

<style>
.col-right {
    text-align: right;
    margin-top: 5px;
}
.margin-top20 {
    margin-top: 20px;
}
</style>
<style scoped>
.org-main {
    height: auto;
    padding-top: 10px;
    position: relative;
}
</style>
